import { Eyebrow, Reveal } from "./Reveal";

const FEATURES = [
    {
        name: "Scan & Shop",
        copy: "Upload a photo or screenshot of an outfit and discover similar pieces, alternatives and where to shop them.",
    },
    {
        name: "Discover",
        copy: "Explore fashion from multiple brands and retailers in one place. Find new arrivals, trending pieces and curated edits.",
    },
    {
        name: "Shop Your Way",
        copy: "Search using words or images, filter by price and discover fashion that suits your personal preferences.",
    },
    {
        name: "The Studio",
        copy: "Create your own fashion moodboards, experiment with styling and build looks using interactive creative tools.",
    },
    {
        name: "My Closet",
        copy: "Digitise your wardrobe, style pieces you already own and discover what complements your existing collection.",
    },
    {
        name: "The Community",
        copy: "Discover style inspiration, share looks and explore fashion through a community of like-minded users.",
    },
];

function FeatureRow({ index, name, copy }) {
    return (
        <div
            className="grid grid-cols-1 gap-4 border-t border-slate-200 py-10 md:grid-cols-12 md:gap-8 md:py-12"
            data-testid={`feature-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        >
            <span className="text-sm font-light text-slate-300 md:col-span-1">0{index}</span>
            <h3 className="text-2xl font-extralight tracking-tight text-slate-950 md:col-span-4">{name}</h3>
            <p className="max-w-md text-base font-extralight leading-relaxed text-slate-600 md:col-span-6 md:col-start-7">
                {copy}
            </p>
        </div>
    );
}

export default function Features() {
    return (
        <section id="features" className="bg-white py-24 md:py-36" data-testid="features-section">
            <div className="mx-auto max-w-[1320px] px-6 sm:px-10 lg:px-16">
                <header className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
                    <div>
                        <Reveal>
                            <Eyebrow>Discover the features</Eyebrow>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h2 className="mt-7 max-w-xl text-4xl font-extralight leading-[1.05] tracking-[-0.03em] text-slate-950 sm:text-5xl lg:text-6xl">
                                Six ways to find{" "}
                                <span className="italic font-light text-slate-950">it.</span>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.15}>
                        <p className="max-w-sm text-base font-extralight leading-relaxed text-slate-600">
                            Every part of EDIT is built around one idea — less searching, more finding.
                        </p>
                    </Reveal>
                </header>

                <div className="mt-14 flex flex-col md:mt-24">
                    {FEATURES.map((f, i) => (
                        <Reveal key={f.name} y={24} amount={0.3}>
                            <FeatureRow index={i + 1} name={f.name} copy={f.copy} />
                        </Reveal>
                    ))}
                    <div className="h-px w-full bg-slate-200" />
                </div>
            </div>
        </section>
    );
}
